'use es6';

import Big from './Big';
import Code from './Code';
import Pre from './Pre';
import Small from './Small';
import HR from './HR';
export { Big, Code, Pre, Small, HR };